export default {
	path: '/resetPassword',
	getComponent(nextState, cb) {
		require.ensure(
			[],
			(require) => {
				cb(null, require('../../pc/retrieve/ResetPassword.js').default)
			},
			'reset-password'
		)
	},
}



// WEBPACK FOOTER //
// ./src/routes/retrieve/resetPassword.js